import {
  Box,
  Container,
  List,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { currentFeatures } from "@/configs/Settings";
import FluxvetOwnerTerms from "./FluxvetOwnerTerms";

export default function TermText({ termOf }: { termOf: string }) {
  const isVet = !currentFeatures.defaultApp;

  // Quando for owner e currentFeatures não for defaultApp (app Fluxvet), exibir Termos de Uso da Plataforma Fluxvet
  if (termOf === "owner" && !currentFeatures.defaultApp) {
    return <FluxvetOwnerTerms />;
  }

  // Se estiver no ambiente vet e for privacy-policy, mostrar termos do Fluxvet
  if (isVet && (termOf === "privacy-policy" || termOf === "patient")) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography variant="h6" align="center" gutterBottom fontWeight={700}>
          POLÍTICA DE PRIVACIDADE
        </Typography>

        <Typography variant="h6" align="center" gutterBottom fontWeight={700}>
          TERMOS DE USO DA PLATAFORMA FLUXVET
        </Typography>

        <Box component="section" mt={4}>
          <Typography variant="h6" gutterBottom>
            1. INTRODUÇÃO
          </Typography>
          <Typography paragraph>
            1.1. Este Termo é oferecido pela FLUXMED - PLATAFORMA PARA SERVIÇOS
            DIGITAIS DE SAUDE LTDA, empresa de tecnologia com sede em
            Brasília/DF, inscrita no CNPJ nº 57.877.539/0001-40 que, de agora em
            diante, será referida como "Fluxmed" ou, simplesmente "nós". A
            Fluxmed é a fornecedora em território brasileiro da plataforma
            Fluxvet.
          </Typography>
          <Typography paragraph>
            1.2. A "Fluxvet" é um software fornecido na forma de SaaS (Software
            as a Service), em constante evolução tecnológica, incluindo e
            disponibilizando novas funcionalidades com frequência. Isso implica
            em constante atualização deste Termo que estará sempre disponível na
            Plataforma para a leitura, atualização e compreensão pelo usuário da
            Plataforma Fluxvet, ou seja, VOCÊ (ou o seu representante legal).
          </Typography>
          <Typography paragraph>
            1.3. VOCÊ, usuário da Fluxvet é um tutor de animais de estimação
            (Pet) de um estabelecimento de saúde veterinária que contratou a
            Plataforma Fluxvet para, por meio dela, prestar a VOCÊ e seu Pet um
            serviço de saúde veterinária. VOCÊ também é um titular de dados
            pessoais e de seu Pet, consumidor que, por meio deste Termo,
            manifesta a sua vontade livre, informada e inequívoca e aceita as
            condições para utilizar o Fluxvet por meio de Aplicativo Fluxmed ou
            pelo portal web.
          </Typography>
          <Typography paragraph>
            1.4 Ao acessar o aplicativo para celulares Fluxmed você também terá
            acesso ao "Fluxvet", um módulo que permite o gerenciamento de
            registros clínicos dos seus animais de estimação, ou simplesmente
            "Pet", sempre que VOCÊ julgar necessário. Uma vez que seu Pet tenha
            sido atendido por uma clínica veterinária usuária do Fluxvet, as
            informações do atendimento poderão ser visualizadas e gerenciadas
            por você. Para saber sobre o módulo Fluxvet, acesse
            https://www.fluxvet.com.br.
          </Typography>
        </Box>

        <Box component="section" mt={4}>
          <Typography variant="h6" gutterBottom>
            2. OBJETIVO E ACEITAÇÃO
          </Typography>
          <Typography paragraph>
            2.1. Este Termo tem como OBJETIVO cumprir com o dever de informar
            VOCÊ, sobre as indicações e limitações de uso, as finalidades, o
            canal de atendimento para dúvidas técnicas, seus direitos e
            obrigações relacionados à utilização do Fluxvet.
          </Typography>
          <Typography paragraph>
            2.2. Além disso, por meio deste Termo queremos mostrar nosso
            compromisso com a Lei Geral de Proteção de Dados Pessoais (Lei nº
            13.709/2018 – "LGPD") e reforçar nosso dever com a transparência e a
            prestação de contas ao descrever: o ciclo de tratamento de seus
            dados pessoais e dados pessoais sensíveis de saúde, a base legal
            adotada, os tratamentos realizados pela Plataforma Fluxvet e nossa
            atuação como Agente de Tratamento com relação ao estabelecimento de
            saúde que VOCÊ vai interagir por meio da Plataforma Fluxvet.
          </Typography>
          <Typography paragraph>
            2.3. Através da leitura deste Termo VOCÊ também vai entender e
            precisa concordar que a aceitação dele é obrigatória para utilizar o
            Fluxvet. Se VOCÊ não concordar com qualquer item deste Termo, VOCÊ
            não poderá utilizar a Plataforma Fluxvet porque este Termo é de
            adesão.
          </Typography>
          <Typography paragraph>
            2.4. Desde já, VOCÊ precisa saber que poderá revogar o seu
            consentimento a qualquer momento e sem nenhum custo. Aliás, a
            Plataforma Fluxvet permite que VOCÊ faça a gestão de seu
            consentimento. Isso significa que VOCÊ poderá gerenciar com quem e
            com quais estabelecimentos de saúde veterinária VOCÊ permite que
            seus dados de saúde sejam compartilhados e visualizados.
          </Typography>
          <Typography paragraph>
            2.5. A Plataforma Fluxvet foi desenvolvida com a premissa de que
            VOCÊ é o protagonista de saúde do seu Pet e titular de seus dados
            pessoais.
          </Typography>
          <Typography paragraph>
            2.6. Assim que VOCÊ realiza o seu cadastro na plataforma, VOCÊ
            precisa saber que VOCÊ recebe um perfil de usuário com visão de
            paciente ou tutor de Pet, as funcionalidades são centradas em VOCÊ.
            Quando seu Pet for atendido em uma ou mais de uma organização de
            saúde veterinária, que também utiliza a plataforma, fique ciente que
            a organização de saúde passa a ser controladora das informações de
            saúde do seu Pet, associado ao seu identificador de CPF - Cadastro
            de Pessoa Física.
          </Typography>
        </Box>

        <Box component="section" mt={4}>
          <Typography variant="h6" gutterBottom>
            3. CONSENTIMENTO DE ACESSO A INFORMAÇÕES PELOS TUTORES DE PET
          </Typography>
          <Typography paragraph>
            3.1. Caso VOCÊ seja um tutor de Pet, VOCÊ pode cadastrar seus
            animais de estimação Pet na plataforma Fluxvet. Na primeira vez que
            seu Pet for atendido por um médico veterinário que utiliza a
            plataforma Fluxvet, a vinculação do seu Pet com você será validada
            pelo profissional que o atender. Com isso você terá acesso aos
            documentos clínicos do seu Pet.
          </Typography>
          <Typography paragraph>
            3.2. As informações clínicas, documentos como: receitas médicas,
            solicitações de exames ou relatórios médicos dos Pets, coletados no
            momento de atendimento veterinário, são os mesmos fornecidos por
            VOCÊ no uso da Plataforma Fluxvet.
          </Typography>
          <Typography paragraph>
            3.3. O tratamento de dados dos Pets será feito da mesma forma que o
            tratamento de dados dos Tutores plenamente capazes civilmente.
          </Typography>
          <Typography paragraph>
            3.3.1. A coleta de dados pessoais e o tratamento dos dados pessoais
            dos Pets serão realizados sempre no seu melhor interesse.
          </Typography>
          <Typography paragraph>
            3.4. O controlador de dados realizará todos os esforços razoáveis
            para verificar que o consentimento que trata o item 3.1. foi dado
            pelo responsável pelo Pet.
          </Typography>
          <Typography paragraph>
            3.5. Caso haja qualquer dúvida referente a esta cláusula VOCÊ poderá
            entrar em contato pelo e-mail: contato@fluxvet.com.br.
          </Typography>
        </Box>

        <Box component="section" mt={4}>
          <Typography variant="h6" gutterBottom>
            4. DESCRIÇÃO DAS FUNCIONALIDADES DA PLATAFORMA FLUXVET E LIMITAÇÕES
            DE USO
          </Typography>
          <Typography paragraph>
            4.1. A "Fluxvet" está hospedada em nuvem no Brasil e tem
            funcionalidades como: armazenamento do prontuário eletrônico,
            agendamento de consultas, emissão de documentos médicos eletrônicos
            (prescrição e pedido de exames), realização de teleconsultas por
            vídeo. Ela também permite que VOCÊ visualize todo o histórico de
            acessos às informações de saúde do seu Pet sempre que VOCÊ quiser, o
            que é um mecanismo adicional de segurança para VOCÊ.
          </Typography>
          <Typography paragraph>
            4.2. No caso de urgência ou emergência procure o atendimento
            presencial, o pronto atendimento ou o pronto socorro mais próximo de
            VOCÊ.
          </Typography>
          <Typography paragraph>
            4.3. Em caso de qualquer dano que VOCÊ sofrer em decorrência do
            serviço de saúde prestado a VOCÊ pelo estabelecimento ou pelo
            profissional de saúde veterinária, VOCÊ não poderá buscar
            indenização perante a Fluxvet.
          </Typography>
          <Typography paragraph>
            4.4. A Fluxvet não é a prestadora do serviço de saúde. VOCÊ deverá
            buscar os seus direitos unicamente perante o estabelecimento de
            saúde.
          </Typography>
          <Typography paragraph>
            4.5. Por meio deste termo você isenta a Fluxvet de qualquer
            responsabilidade relacionada à prestação de serviços de saúde
            veterinária.
          </Typography>
          <Typography paragraph>
            4.6. Consentimento é a base legal adotada pela Fluxvet para tratar
            suas informações e as de saúde veterinária do seu Pet (art. 11, da
            LGPD).
          </Typography>
          <Typography paragraph>
            4.7. A Fluxvet, enquanto plataforma de interoperabilidade contratada
            pela organização de saúde veterinária e/ou profissional de saúde
            veterinaria responsável pela sua assistência, compromete-se a
            respeitar a sua privacidade e proteger os seus dados pessoais e
            dados pessoais sensíveis, especialmente aqueles relacionados à
            saúde, no papel de operadora de dados. VOCÊ precisa saber que, nos
            termos da Lei Geral de Proteção de Dados Pessoais (LGPD), é proibido
            o uso compartilhado ou a comunicação entre controladores de dados
            com fins de obtenção de vantagem econômica, exceto nos seguintes
            casos, observados os seus interesses como titular de dados pessoais
            e como paciente:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 4 }}>
            <li>
              <Typography component="span">
                4.7.1. Quando necessário para a prestação de serviços de saúde
                veterinária, de assistência farmacêutica e de assistência à
                saúde veterinária, incluindo os serviços auxiliares de diagnose
                e terapia, sempre em benefício dos titulares dos dados;
              </Typography>
            </li>
            <li>
              <Typography component="span">
                4.7.2. Para garantir a portabilidade de dados, caso seja
                solicitado por VOCÊ;
              </Typography>
            </li>
            <li>
              <Typography component="span">
                4.7.3. Para viabilizar transações financeiras e administrativas
                decorrentes do uso e da prestação de serviços oferecidos pela
                organização de saúde.
              </Typography>
            </li>
          </List>
          <Typography paragraph>
            4.8. Por meio deste termo VOCÊ concede este consentimento ao
            estabelecimento de saúde veterinária que estiver realizando o
            atendimento por meio da Plataforma Fluxvet.
          </Typography>
          <Typography paragraph>
            4.9. A Plataforma Fluxvet permite que VOCÊ faça a gestão de seu
            consentimento. Isso significa que VOCÊ poderá gerenciar com quem e
            com quais estabelecimentos de saúde veterinária que VOCÊ permite que
            suas informações sejam compartilhadas e visualizadas.
          </Typography>
        </Box>

        <Box component="section" mt={4}>
          <Typography variant="h6" gutterBottom>
            5. COMO INFORMAÇÕES DE SAÚDE DO SEU PET SÃO OPERADAS PELA FLUXVET
          </Typography>
          <Typography paragraph>
            5.1. A Plataforma Fluxvet opera as suas informações e as de saúde
            veterinária do seu Pet, na forma de ("usuário-paciente"),
            eventualmente, e por profissionais de uma organização de saúde
            veterinária ("usuário-autorizado"), em seu benefício e do seu Pet
            para a sua assistência.
          </Typography>
          <Typography paragraph>
            5.2. Cadastro de dados pessoais de identificação: para VOCÊ se
            cadastrar à Plataforma Fluxvet, pelo aplicativo para celulares
            disponíveis ou pelo portal web - https://app.fluxvet.com.br, VOCÊ
            vai precisar inserir os seguintes dados pessoais de identificação
            para gerar o login e senha de acesso à Plataforma Fluxvet:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 4 }}>
            <li>
              <Typography component="span">5.2.1. Nome completo;</Typography>
            </li>
            <li>
              <Typography component="span">
                5.2.2. Data de nascimento;
              </Typography>
            </li>
            <li>
              <Typography component="span">
                5.2.3. Sexo de nascimento;
              </Typography>
            </li>
            <li>
              <Typography component="span">5.2.4. Número de CPF;</Typography>
            </li>
            <li>
              <Typography component="span">5.2.5. E-mail;</Typography>
            </li>
            <li>
              <Typography component="span">
                5.2.6. Número de celular.
              </Typography>
            </li>
          </List>
          <Typography paragraph>
            5.3. VOCÊ precisa saber que, ao se cadastrar na plataforma Fluxvet
            você também será cadastrado na plataforma Fluxmed, plataforma
            desenvolvida para serviços digitais de saúde. O acesso a plataforma
            Fluxmed, bem como os termos de uso estão acessíveis respectivamente
            em https://app.fluxmed.com.br e
            https://fluxmed.com.br/politica-de-privacidade/.
          </Typography>
          <Typography paragraph>
            5.3.1 Ao cancelar sua conta no Fluxvet ou Fluxmed você deixará de
            ter acesso em ambas as plataformas.
          </Typography>
          <Typography paragraph>
            5.3.2 Para assegurar a sua identificação e para evitar fraudes a
            Fluxvet faz a validação de seus dados junto à Receita Federal do
            Brasil, envia um token de validação por SMS para seu número de
            telefone informado ou um e-mail para poder validar o seu cadastro.
            Por isso solicitamos estas informações para VOCÊ.
          </Typography>
          <Typography paragraph>
            5.4. Não forneça informações imprecisas sobre a sua identificação,
            proteja sua senha não fornecendo-a a ninguém, se precisar que outras
            pessoas além de VOCÊ tenha acesso às suas informações de saúde,
            utilize os mecanismos de consentimento disponíveis nos aplicativos
            Fluxvet.
          </Typography>
          <Typography paragraph>
            5.5. Após realizado o cadastro, você poderá utilizar as
            funcionalidades da Plataforma Fluxvet, fazer a gestão de seus dados
            pessoais e de sua saúde na palma da sua mão!
          </Typography>
          <Typography paragraph>
            5.6. Caso solicitado pelo estabelecimento de saúde, a Fluxvet pode
            processar suas informações de saúde na forma de tabelas, dashboards.
            Isso permite que o estabelecimento de saúde otimize a gestão da
            saúde populacional de seus pacientes.
          </Typography>
          <Typography paragraph>
            5.7. VOCÊ precisa saber que a LGPD proíbe a realização de tratamento
            para fins discriminatórios ilícitos ou abusivos.
          </Typography>
          <Typography paragraph>
            5.8. A Fluxvet é o operador de dados.
          </Typography>
          <Typography paragraph>
            5.8.1. Fluxvet atua como operador de dados porque ela trata os seus
            dados pessoais e os de seus Pets conforme as finalidades
            estabelecidas pelo estabelecimento de saúde veterinária, que é o
            controlador de dados.
          </Typography>
          <Typography paragraph>
            5.10. Enquanto seu Pet não for atendido por um estabelecimento de
            saúde por meio da Plataforma Fluxvet, VOCÊ poderá pedir à Fluxvet
            para eliminar seus dados cadastrais. VOCÊ precisa buscar o canal de
            exercício de direitos da LGPD perante o estabelecimento de saúde
            onde seu Pet foi atendido.
          </Typography>
          <Typography paragraph>
            5.10. Por padrão a Plataforma Fluxvet envia mensagens de texto via
            WhatsApp, SMS ou e-mail com informações acerca do atendimento do seu
            Pet, como por exemplo, agendamento e cancelamento de consultas;
            solicitações de exames; receitas médicas ou qualquer comunicação que
            possam auxiliar no acompanhamento das condutas clínicas adotadas
            pelo médico veterinário ou que possam auxiliar na condução do seu
            tratamento. Também poderão ser enviadas mensagens contendo
            solicitação de consentimento diversos, que caberá a VOCÊ, a decisão
            de aceita-las. VOCÊ pode desativar o recebimento de notificações a
            qualquer momento, fazendo seu cadastro, ou se já for cadastrado,
            editando seu perfil de usuário, localizado na canto superior direito
            da sua tela no ícone com as iniciais do seu nome ou foto.
          </Typography>
          <Typography paragraph>
            5.10. Se VOCÊ tiver alguma dúvida sobre as funcionalidades ou tiver
            algum problema técnico para utilizar a Plataforma Fluxvet, VOCÊ pode
            pedir ajuda técnica para a Fluxvet por meio do seguinte e-mail:
            contato@fluxvet.com.br.
          </Typography>
          <Typography paragraph>
            5.12. Atenção: Não envie à Fluxvet nenhuma pergunta relacionada à
            sua saúde ou de seu Pet. Procure o estabelecimento de saúde, o
            profissional de saúde ou o seu médico assistencial ou o veterinário
            de seu Pet.
          </Typography>
          <Typography paragraph>
            5.13. Integração com sua conta de usuário do Google - USUÁRIO DO
            GOOGLE.
          </Typography>
          <Typography paragraph>
            5.13.1 O Fluxvet permite que você associe sua conta Fluxvet, com a
            sua conta do Google. O Fluxvet fornece funcionalidade de integração
            das agendas de atendimento gerenciadas no Fluxvet com seu Google
            Calendar, ou outrora, chamado de Google Agenda.
          </Typography>
          <Typography paragraph>
            5.13.2 A integração é individual, cada pessoa identificada e
            autenticada no Fluxvet, profissional ou paciente, pode realização a
            integração com o Google Calendar.
          </Typography>
          <Typography paragraph>
            5.13.3 Quais dados da sua conta Google são acessados: seu nome,
            endereço de e-mail, foto do perfil, e ainda caso permita, ver e
            editar eventos em todas as suas agendas.
          </Typography>
          <Typography paragraph>
            5.13.3 Como utilizamos sua conta Google
          </Typography>
          <Typography paragraph>
            5.13.3.1 Usaremos seus dados para enviar, de forma automatizada e
            uma vez configurada por VOCÊ, informações sobre as agendas de
            atendimento, e ainda, notificações por e-mail e newsletter etc.
          </Typography>
          <Typography paragraph>
            5.13.3.2 Não venderemos seus dados a terceiros, mas podemos
            compartilhá-los com prestadores de serviços de saúde que utilizam o
            Fluxvet, isto porque, prestadores de serviços de saúde, médicos e
            profissionais de saúde são controladores de dados, conforme a LGPD e
            apresentado no item 5.8.
          </Typography>
          <Typography paragraph>
            5.13.3.3 O Fluxmed segue rigorasamente as políticas da Google para -
            Limitações de uso dos dados de usuários - ou em inglês acessível no
            link, "Limited use of user data" -{" "}
            <a
              href="https://developers.google.com/workspace/workspace-api-user-data-developer-policy#limited-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://developers.google.com/workspace/workspace-api-user-data-developer-policy#limited-use
            </a>
            , e nossos desenvolvedores da - Política de Dados do Usuário e do
            Desenvolvedor da API do Workspace - ou em inglês, acessível no link,
            "Workspace API User Data and Developer Policy" -{" "}
            <a
              href="https://developers.google.com/workspace/workspace-api-user-data-developer-policy"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://developers.google.com/workspace/workspace-api-user-data-developer-policy
            </a>
            .
          </Typography>
        </Box>

        <Box component="section" mt={4}>
          <Typography variant="h6" gutterBottom>
            6. TEMPO DE ARMAZENAMENTO
          </Typography>
          <Typography paragraph>
            6.1. Ao contrário do estabelecimento de saúde, a Fluxvet não é
            obrigada a conservar seus dados pessoais. Por isso, a plataforma
            fornece à organização de saúde veterinária mecanismos para extração
            de dados por ela controlados.
          </Typography>
        </Box>

        <Box component="section" mt={4}>
          <Typography variant="h6" gutterBottom>
            7. MEDIDAS DE SEGURANÇA
          </Typography>
          <Typography paragraph>
            7.1. A Fluxvet encoraja que VOCÊ este Termo com calma e atenção
            antes mesmo de realizar o cadastro na Plataforma Fluxvet.
          </Typography>
          <Typography paragraph>
            7.2. Se VOCÊ tiver qualquer dúvida relacionada ao presente Termo,
            VOCÊ pode enviar um e-mail para: contato@fluxvet.com.br.
          </Typography>
          <Typography paragraph>
            7.3. Realizado o cadastro, VOCÊ declara e concorda que seus dados de
            login e senha para acessar a Plataforma Fluxvet são pessoais e
            pertencem a VOCÊ. VOCÊ não pode revelar ou transferir seu login e
            senha para ninguém.
          </Typography>
          <Typography paragraph>
            7.4. VOCÊ é o responsável pelos seus dados pessoais de cadastro e de
            seus Pets, por mais que sejam validados pela Fluxvet. Isso significa
            que a Fluxvet não será responsável por garantir que VOCÊ é a pessoa
            que cadastrou VOCÊ à Plataforma Fluxvet.
          </Typography>
          <Typography paragraph>
            7.5. A Fluxvet tampouco será responsável pela segurança de seus
            dados pessoais compartilhados por VOCÊ em outros ambientes como
            e-mail, WhatsApp, ou quaisquer outros sistemas similares de
            mensageria.
          </Typography>
          <Typography paragraph>
            7.6. Todos os acessos à Plataforma Fluxvet são rastreáveis, não
            podem ser alterados e podem ser visualizados por VOCÊ.
          </Typography>
        </Box>

        <Box component="section" mt={4}>
          <Typography variant="h6" gutterBottom>
            8. COMO É FEITA A PROTEÇÃO DOS SEUS DADOS
          </Typography>
          <Typography paragraph>
            8.1. O controlador de dados (clínicas, prestadores de serviço de
            saúde, médicos e profissionais de saúde) e o operador de dados,
            protegem a confidencialidade de dados pessoais e dados sensíveis que
            lhe são confiados pelos titulares desses dados. Para isso, vêm
            implementando medidas de segurança, técnicas e administrativas,
            aptas a proteger dados pessoais e dados sensíveis contra acessos não
            autorizados e de situações acidentais, ou qualquer forma de
            tratamento inadequado, necessárias ao cumprimento da Lei Geral de
            Proteção de Dados (Lei nº 13.709/2018). Regras de boas práticas e de
            governança garantem que o tratamento de dados pessoais e sensíveis
            seja lícito, leal, transparente e limitado às finalidades
            autorizadas a que se destina. A coleta de dados pessoais e dados
            sensíveis para tratamento é realizada pelas Partes com base em
            medidas necessárias para assegurar a exatidão, integridade,
            confidencialidade, e anonimização, bem como garantir o respeito à
            liberdade, privacidade, inviolabilidade da intimidade, imagem,
            enfim, todos os direitos dos titulares, inclusive o exercício do
            direito de solicitar acesso, correção e eliminação de dados pessoais
            e sensíveis armazenados em banco de dados e sistemas digitais.
          </Typography>
        </Box>

        <Box component="section" mt={4}>
          <Typography variant="h6" gutterBottom>
            9. EXCLUSÃO E RETENÇÃO DE DADOS, INCLUSIVE DO USUÁRIO GOOGLE
          </Typography>
          <Typography paragraph>
            9.1 Armazenamos suas informações pessoais por um período de tempo
            consistente e em conformidade com as legislações vigentes. o Fluxvet
            disponibiliza funcionalidade para que você possa cancelar sua conta
            no Fluxvet, quando VOCÊ cancelar sua conta, iremos disponibilizar
            para "download", todas as informações contidas no Fluxvet. Faça o
            download e guarde em dispositivo seguro. É seu direito.
          </Typography>
          <Typography paragraph>
            9.2. Controladores de dados têm a responsabilidade de reter seus
            dados conforme diz a Resolução CFM nº 1.821/2007. Cabe a VOCÊ
            procurar os prestadores de serviços de saúde, clínicas, médicos e
            profissionais que utilizaram o Fluxvet para registro do seu
            atendimento, e solicitar a exclusão dos seus dados.
          </Typography>
          <Typography paragraph>
            9.2.1. Uma vez recebida a solicitação de exclusão de seus dados pelo
            Controlador de Dados, eles serão excluídos da Plataforma no prazo de
            24 horas e você será notificado no e-mail cadastrado.
          </Typography>
          <Typography paragraph>
            9.3. O Fluxvet permite que VOCÊ revogue o compartilhamento e o
            consentimento de acesso aos seus dados, uma vez configurado por
            VOCÊ, seus dados não poderão ser visualizados, baixados ou
            processados pela plataforma.
          </Typography>
        </Box>

        <Box component="section" mt={4}>
          <Typography variant="h6" gutterBottom>
            10. INSTRUÇÕES FINAIS PARA O BOM USO DO APLICATIVO E LIMITES
          </Typography>
          <Typography paragraph>
            10.1. Ao utilizar a Plataforma Fluxvet VOCÊ reconhece e concorda que
            a disponibilidade e o funcionamento da Plataforma Fluxvet, como
            qualquer tecnologia de informação e comunicação estão sujeitos a
            interrupções devido a fatores que estão fora do controle da Fluxvet,
            incluindo, mas não se limitando a:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 4 }}>
            <li>
              <Typography component="span">
                10.1.1. Indisponibilidade de energia elétrica;
              </Typography>
            </li>
            <li>
              <Typography component="span">
                10.1.2. Falhas no sinal de internet e velocidade inadequada de
                conexão;
              </Typography>
            </li>
            <li>
              <Typography component="span">
                10.1.3. Falhas de software em reparação;
              </Typography>
            </li>
            <li>
              <Typography component="span">
                10.1.4. Desastres ambientais.
              </Typography>
            </li>
          </List>
          <Typography paragraph>
            10.2. Em casos de interrupções devido a manutenções programadas,
            falhas de software ou qualquer outro fator que afete a
            disponibilidade da Plataforma Fluxvet, VOCÊ pode tomar as seguintes
            ações:
          </Typography>
          <List sx={{ listStyleType: "disc", pl: 4 }}>
            <li>
              <Typography component="span">
                10.2.1. Verificar comunicados. Pode ser que exista alguma
                notificação indicando a indisponibilidade.
              </Typography>
            </li>
            <li>
              <Typography component="span">
                10.2.2. Reportar problemas. Se encontrar um problema não
                comunicado previamente, é útil reportá-lo à equipe de suporte
                técnico da plataforma Fluxvet por meio do e-mail:
                contato@fluxvet.com.br.
              </Typography>
            </li>
            <li>
              <Typography component="span">
                10.2.3. Revisar este termo. Recomendamos que VOCÊ revise este
                termo sempre que quiser ou quando for necessário.
              </Typography>
            </li>
          </List>
          <Typography paragraph>
            10.3. O uso da Plataforma Fluxvet é condicionado à adesão integral
            destes termos.
          </Typography>
          <Typography paragraph>
            10.4. Reiteramos: no caso de urgência ou emergência procure o
            atendimento presencial, o pronto atendimento ou o pronto socorro
            mais próximo de VOCÊ.
          </Typography>
        </Box>
      </Container>
    );
  }

  return termOf !== "owner" ? (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h6" align="center" gutterBottom fontWeight={700}>
        POLÍTICA DE PRIVACIDADE
      </Typography>

      <Typography variant="h6" align="center" gutterBottom fontWeight={700}>
        TERMOS DE USO DA PLATAFORMA FLUXMED E PROTEÇÃO DE DADOS PESSOAIS
        ("Termo")
      </Typography>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          1. INTRODUÇÃO
        </Typography>
        <Typography paragraph>
          1.1. Este Termo é oferecido pela FLUXMED – PLATAFORMA PARA SERVIÇOS
          DIGITAIS DE SAÚDE LTDA, empresa de tecnologia com sede em Brasília/DF,
          inscrita no CNPJ nº 57.877.539/0001-40 que, de agora em diante, será
          referida como "Fluxmed" ou, simplesmente "nós".
        </Typography>
        <Typography paragraph>
          1.2. A "Fluxmed" é uma plataforma de desenvolvimento de serviços
          digitais de saúde, em constante evolução tecnológica, incluindo e
          disponibilizando novas funcionalidades com frequência. Isso implica em
          constante atualização deste Termo que estará sempre disponível na
          Plataforma para a leitura, atualização e compreensão pelo usuário da
          Plataforma Fluxmed, ou seja, VOCÊ (ou o seu representante legal).
        </Typography>
        <Typography paragraph>
          1.3. VOCÊ (ou seu representante legal), usuário da Fluxmed é um
          paciente do estabelecimento de saúde que contratou a Plataforma
          Fluxmed para, por meio dela, prestar a VOCÊ um serviço de saúde. VOCÊ
          também é um titular de dados pessoais, consumidor que, por meio deste
          Termo, manifesta a sua vontade livre, informada e inequívoca e aceita
          as condições para utilizar o Fluxmed por meio de Aplicativo ou pela
          web.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          2. OBJETIVO E ACEITAÇÃO
        </Typography>
        <Typography paragraph>
          2.1. Este Termo tem como OBJETIVO cumprir com o dever de informar
          VOCÊ, sobre as indicações e limitações de uso, as finalidades, o canal
          de atendimento para dúvidas técnicas, seus direitos e obrigações
          relacionados à utilização do Fluxmed.
        </Typography>
        <Typography paragraph>
          2.2. Além disso, por meio deste Termo queremos mostrar nosso
          compromisso com a Lei Geral de Proteção de Dados Pessoais (Lei nº
          13.709/2018 – "LGPD") e reforçar nosso dever com a transparência e a
          prestação de contas ao descrever: o ciclo de tratamento de seus dados
          pessoais e dados pessoais sensíveis de saúde, a base legal adotada, os
          tratamentos realizados pela Plataforma Fluxmed e nossa atuação como
          Agente de Tratamento com relação ao estabelecimento de saúde que VOCÊ
          vai interagir por meio da Plataforma Fluxmed.
        </Typography>
        <Typography paragraph>
          2.3. Através da leitura deste Termo VOCÊ também vai entender e precisa
          concordar que a aceitação dele é obrigatória para utilizar o Fluxmed.
          Se VOCÊ não concordar com qualquer item deste Termo VOCÊ não poderá
          utilizar a Plataforma Fluxmed porque este Termo é de adesão.
        </Typography>
        <Typography paragraph>
          2.4. Desde já, VOCÊ precisa saber que poderá revogar o seu
          consentimento a qualquer momento e sem nenhum custo. Aliás, a
          Plataforma Fluxmed permite que VOCÊ faça a gestão de seu
          consentimento. Isso significa que VOCÊ poderá gerenciar com quem e com
          quais estabelecimentos de saúde VOCÊ permite que seus dados de saúde
          sejam compartilhados e visualizados.
        </Typography>
        <Typography paragraph>
          2.5. A Plataforma Fluxmed foi desenvolvida com a premissa de que VOCÊ
          é o protagonista de sua saúde e titular de seus dados pessoais.
        </Typography>
        <Typography paragraph>
          2.6. Assim que VOCÊ realiza o seu cadastro na plataforma, VOCÊ precisa
          saber que VOCÊ recebe um perfil de usuário com visão de paciente, as
          funcionalidades são centradas em VOCÊ. Quando VOCÊ for atendido em uma
          ou mais de uma organização de saúde, que também utiliza a plataforma,
          fique ciente que a organização de saúde passa a ser controladora das
          suas informações de saúde.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          3. CONSENTIMENTO DE ACESSO A INFORMAÇÕES PELOS PAIS OU REPRESENTANTES
          LEGAIS
        </Typography>
        <Typography paragraph>
          3.1. Caso VOCÊ seja um dos pais do menor ou seu representante legal,
          VOCÊ pode informar seu dependente legal ou filho(a) utilizando a
          função "Minha Família" na plataforma Fluxmed. Na primeira vez que seu
          dependente legal ou filho(a) for atendido por um médico que utiliza a
          plataforma Fluxmed, a vinculação do seu dependente legal ou filho(a)
          com você será validada pelo profissional que o atender. Com isso você
          terá acesso aos documentos clínicos do seu dependente legal ou
          filho(a).
        </Typography>
        <Typography paragraph>
          3.2. As informações clínicas, documentos como: receitas médicas,
          solicitações de exames ou relatórios médicos dos filhos(as) ou dos
          representados, coletados no momento de atendimento médico, são os
          mesmos fornecidos por VOCÊ no uso da Plataforma Fluxmed.
        </Typography>
        <Typography paragraph>
          3.3. O tratamento de dados dos menores ou representados serão feitos
          da mesma forma que o tratamento de dados para os maiores ou plenamente
          capazes civilmente.
        </Typography>
        <Typography paragraph>
          3.3.1. A coleta de dados pessoais e o tratamento dos dados pessoais
          dos menores ou representados serão realizados sempre no seu melhor
          interesse.
        </Typography>
        <Typography paragraph>
          3.4. O controlador de dados realizará todos os esforços razoáveis para
          verificar que o consentimento que trata o item 3.1. foi dado pelo
          responsável pela criança ou adolescente ou representado.
        </Typography>
        <Typography paragraph>
          3.5. Caso haja qualquer dúvida referente a esta cláusula VOCÊ poderá
          entrar em contato pelo e-mail: contato@fluxmed.com.br.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          4. DESCRIÇÃO DAS FUNCIONALIDADES DA PLATAFORMA FLUXMED E LIMITAÇÕES DE
          USO
        </Typography>
        <Typography paragraph>
          4.1. A "Fluxmed" está hospedada em nuvem no Brasil e tem
          funcionalidades como: armazenamento do prontuário eletrônico,
          agendamento de consultas, emissão de documentos médicos eletrônicos
          (prescrição, pedido de exames, atestado), realização de teleconsultas
          por vídeo. Ela também permite que VOCÊ visualize todo o histórico de
          acessos às suas informações de saúde sempre que VOCÊ quiser, o que é
          um mecanismo adicional de segurança para VOCÊ.
        </Typography>
        <Typography paragraph>
          4.2. No caso de urgência ou emergência procure o atendimento
          presencial, o pronto atendimento ou o pronto socorro mais próximo de
          VOCÊ.
        </Typography>
        <Typography paragraph>
          4.3. Em caso de qualquer dano que VOCÊ sofrer em decorrência do
          serviço de saúde prestado a VOCÊ pelo estabelecimento ou pelo
          profissional de saúde, VOCÊ não poderá buscar indenização perante a
          Fluxmed.
        </Typography>
        <Typography paragraph>
          4.4. A Fluxmed não é a prestadora do serviço de saúde. VOCÊ deverá
          buscar os seus direitos unicamente perante o estabelecimento de saúde.
        </Typography>
        <Typography paragraph>
          4.5. Por meio deste termo você isenta a Fluxmed de qualquer
          responsabilidade relacionada à prestação de serviços de saúde.
        </Typography>
        <Typography paragraph>
          4.6. Consentimento é a base legal adotada pela Fluxmed para tratar
          suas informações de saúde (art. 11, da LGPD).
        </Typography>
        <Typography paragraph>
          4.7. A Fluxmed, enquanto plataforma de interoperabilidade contratada
          pela organização de saúde e/ou profissional de saúde responsável pela
          sua assistência, compromete-se a respeitar a sua privacidade e
          proteger os seus dados pessoais e dados pessoais sensíveis,
          especialmente aqueles relacionados à saúde, no papel de operadora de
          dados. VOCÊ precisa saber que, nos termos da Lei Geral de Proteção de
          Dados Pessoais (LGPD), é proibido o uso compartilhado ou a comunicação
          entre controladores de dados de saúde com fins de obtenção de vantagem
          econômica, exceto nos seguintes casos, observados os seus interesses
          como titular de dados pessoais e como paciente:
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <li>
            <Typography component="span">
              4.7.1. Quando necessário para a prestação de serviços de saúde, de
              assistência farmacêutica e de assistência à saúde, incluindo os
              serviços auxiliares de diagnose e terapia, sempre em benefício dos
              titulares dos dados;
            </Typography>
          </li>
          <li>
            <Typography component="span">
              4.7.2. Para garantir a portabilidade de dados, caso seja
              solicitado por VOCÊ;
            </Typography>
          </li>
          <li>
            <Typography component="span">
              4.7.3. Para viabilizar transações financeiras e administrativas
              decorrentes do uso e da prestação de serviços oferecidos pela
              organização de saúde.
            </Typography>
          </li>
        </List>
        <Typography paragraph>
          4.8. Ainda, conforme a legislação vigente, é vedado às operadoras de
          planos privados de saúde o tratamento de dados de saúde para a prática
          de seleção de riscos ao contratar ou excluir beneficiários (art. 11,
          §5º, da LGPD).
        </Typography>
        <Typography paragraph>
          4.9. Por meio deste termo VOCÊ concede este consentimento ao
          estabelecimento de saúde que estiver realizando o seu atendimento por
          meio da Plataforma Fluxmed.
        </Typography>
        <Typography paragraph>
          4.10. A Plataforma Fluxmed permite que VOCÊ faça a gestão de seu
          consentimento. Isso significa que VOCÊ poderá gerenciar com quem e com
          quais estabelecimentos de saúde VOCÊ permite que suas informações de
          saúde sejam compartilhadas e visualizadas.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          5. COMO SUAS INFORMAÇÕES DE SAÚDE SÃO OPERADAS PELA FLUXMED
        </Typography>
        <Typography paragraph>
          5.1. A Plataforma Fluxmed opera as suas informações de saúde na forma
          de ("usuário-paciente"), eventualmente, e por profissionais de saúde
          de uma organização de saúde ("usuário-autorizado"), em seu benefício e
          para a sua assistência.
        </Typography>
        <Typography paragraph>
          5.2. Cadastro de dados pessoais de identificação: para VOCÊ se
          cadastrar à Plataforma Fluxmed, aplicativo ou web, VOCÊ vai precisar
          inserir os seguintes dados pessoais de identificação para gerar o
          login e senha de acesso à Plataforma Fluxmed:
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <li>
            <Typography component="span">5.2.1. Nome completo;</Typography>
          </li>
          <li>
            <Typography component="span">5.2.2. Data de nascimento;</Typography>
          </li>
          <li>
            <Typography component="span">5.2.3. Sexo de nascimento;</Typography>
          </li>
          <li>
            <Typography component="span">5.2.4. Número de CPF;</Typography>
          </li>
          <li>
            <Typography component="span">5.2.5. E-mail;</Typography>
          </li>
          <li>
            <Typography component="span">5.2.6. Número de celular.</Typography>
          </li>
        </List>
        <Typography paragraph>
          5.3. VOCÊ precisa saber que, para assegurar a sua identificação e para
          evitar fraudes a Fluxmed faz a validação de seus dados junto à Receita
          Federal do Brasil, envia um token de validação por SMS para seu número
          de telefone informado ou um e-mail para poder validar o seu cadastro.
          Por isso solicitamos estas informações para VOCÊ.
        </Typography>
        <Typography paragraph>
          5.4. Não forneça informações imprecisas sobre a sua identificação,
          proteja sua senha não fornecendo-a a ninguém, se precisar que outras
          pessoas além de VOCÊ tenham acesso às suas informações de saúde,
          utilize os mecanismos de consentimento disponíveis nos aplicativos
          Fluxmed.
        </Typography>
        <Typography paragraph>
          5.5. Após realizado o cadastro VOCÊ poderá utilizar as funcionalidades
          da Plataforma Fluxmed, fazer a gestão de seus dados pessoais e de sua
          saúde na palma da sua mão!
        </Typography>
        <Typography paragraph>
          5.6. Caso solicitado pelo estabelecimento de saúde, a Fluxmed pode
          processar suas informações de saúde na forma de tabelas, dashboards.
          Isso permite que o estabelecimento de saúde otimize a gestão da saúde
          populacional de seus pacientes.
        </Typography>
        <Typography paragraph>
          5.7. VOCÊ precisa saber que a LGPD proíbe a realização de tratamento
          para fins discriminatórios ilícitos ou abusivos.
        </Typography>
        <Typography paragraph>5.8. A Fluxmed é o operador de dados.</Typography>
        <Typography paragraph>
          5.8.1. Fluxmed atua como operador de dados porque ela trata os seus
          dados pessoais conforme as finalidades estabelecidas pelo
          estabelecimento de saúde, que é o controlador de dados.
        </Typography>
        <Typography paragraph>
          5.9. Enquanto VOCÊ não for atendido por um estabelecimento de saúde
          por meio da Plataforma Fluxmed, VOCÊ poderá pedir à Fluxmed para
          eliminar seus dados cadastrais. VOCÊ precisa buscar o canal de
          exercício de direitos da LGPD perante o estabelecimento de saúde onde
          VOCÊ foi atendido.
        </Typography>
        <Typography paragraph>
          5.10. Por padrão a Plataforma Fluxmed envia mensagens de texto via
          WhatsApp, SMS ou e-mail com informações acerca do seu atendimento,
          como por exemplo, o agendamento de consultas; as solicitações de
          exames; as receitas médicas ou qualquer comunicação que possam
          auxiliar no acompanhamento das condutas clínicas adotadas pelo seu
          médico ou que possam auxiliar na condução do seu tratamento. Também
          poderão ser enviadas mensagens contendo solicitação de consentimento
          diversos, que caberá a VOCÊ, a decisão de aceita-las. VOCÊ pode
          desativar o recebimento de notificações a qualquer momento, fazendo
          seu cadastro, ou se já for cadastrado, clicando no ícone de sino,
          localizado na canto superior direito da sua tela.
        </Typography>
        <Typography paragraph>
          5.11. Se VOCÊ tiver alguma dúvida sobre as funcionalidades ou tiver
          algum problema técnico para utilizar a Plataforma Fluxmed, VOCÊ pode
          pedir ajuda técnica para a Fluxmed por meio do seguinte e-mail:
          contato@fluxmed.com.br.
        </Typography>
        <Typography paragraph>
          5.12. Atenção: Não envie à Fluxmed nenhuma pergunta relacionada à sua
          saúde. Procure o estabelecimento de saúde, o profissional de saúde ou
          o seu médico assistencial.
        </Typography>
        <Typography paragraph>
          5.13. Integração com sua conta de usuário do Google - USUÁRIO DO
          GOOGLE.
        </Typography>
        <Typography paragraph>
          5.13.1 O Fluxmed permite que você associe sua conta Fluxmed, com a sua
          conta do Google. O FLuxmed fornece funcionalidade de integração das
          agendas de atendimento gerenciadas no Fluxmed com seu Google Calendar,
          ou outrora, chamado de Google Agenda.
        </Typography>
        <Typography paragraph>
          5.13.2 A integração é individual, cada pessoa identificada e
          autenticada no Fluxmed, profissional ou paciente, pode realização a
          integração com o Google Calendar.
        </Typography>
        <Typography paragraph>
          5.13.3 Quais dados da sua conta Google são acessados: seu nome,
          endereço de e-mail, foto do perfil, e ainda caso permita, ver e editar
          eventos em todas as suas agendas.
        </Typography>
        <Typography paragraph>
          5.13.3 Como utilizamos sua conta Google
        </Typography>
        <Typography paragraph>
          5.13.3.1 Usaremos seus dados para enviar, de forma automatizada e uma
          vez configurada por VOCÊ, informações sobre as agendas de atendimento,
          e ainda, notificações por e-mail e newsletter etc.
        </Typography>
        <Typography paragraph>
          5.13.3.2 Não venderemos seus dados a terceiros, mas podemos
          compartilhá-los com prestadores de serviços de saúde que utilizam o
          Fluxmed, isto porque, prestadores de serviços de saúde, médicos e
          profissionais de saúde são controladores de dados, conforme a LGPD e
          apresentado no item 5.8.
        </Typography>
        <Typography paragraph>
          5.13.3.3 O Fluxmed segue rigorasamente as políticas da Google para -
          Limitações de uso dos dados de usuários - ou em inglês acessível no
          link, "Limited use of user data" -{" "}
          <a
            href="https://developers.google.com/workspace/workspace-api-user-data-developer-policy#limited-use"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://developers.google.com/workspace/workspace-api-user-data-developer-policy#limited-use
          </a>
          , e nossos desenvolvedores da - Política de Dados do Usuário e do
          Desenvolvedor da API do Workspace - ou em inglês, acessível no link,
          "Workspace API User Data and Developer Policy" -{" "}
          <a
            href="https://developers.google.com/workspace/workspace-api-user-data-developer-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://developers.google.com/workspace/workspace-api-user-data-developer-policy
          </a>
          .
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          6. TEMPO DE ARMAZENAMENTO
        </Typography>
        <Typography paragraph>
          6.1. Ao contrário do estabelecimento de saúde, a Fluxmed não é
          obrigada a conservar seus dados pessoais. Por isso, a plataforma
          fornece à organização de saúde mecanismos para extração de dados por
          ela controlados.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          7. MEDIDAS DE SEGURANÇA
        </Typography>
        <Typography paragraph>
          7.1. A Fluxmed encoraja que VOCÊ este Termo com calma e atenção antes
          mesmo de realizar o cadastro na Plataforma Fluxmed.
        </Typography>
        <Typography paragraph>
          7.2. Se VOCÊ tiver qualquer dúvida relacionada ao presente Termo, VOCÊ
          pode enviar um e-mail para: contato@fluxmed.com.br.
        </Typography>
        <Typography paragraph>
          7.3. Realizado o cadastro, VOCÊ declara e concorda que seus dados de
          login e senha para acessar a Plataforma Fluxmed são pessoais e
          pertencem a VOCÊ. VOCÊ não pode revelar ou transferir seu login e
          senha para ninguém.
        </Typography>
        <Typography paragraph>
          7.4. VOCÊ é o responsável pelos seus dados pessoais de cadastro, por
          mais que sejam validados pela Fluxmed. Isso significa que a Fluxmed
          não será responsável por garantir que VOCÊ é a pessoa que cadastrou
          VOCÊ à Plataforma Fluxmed.
        </Typography>
        <Typography paragraph>
          7.5. A Fluxmed tampouco será responsável pela segurança de seus dados
          pessoais compartilhados por VOCÊ em outros ambientes como e-mail,
          WhatsApp, ou quaisquer outros sistemas similares de mensageria.
        </Typography>
        <Typography paragraph>
          7.6. Todos os acessos à Plataforma Fluxmed são rastreáveis, não podem
          ser alterados e podem ser visualizados por VOCÊ.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          8. COMO É FEITA A PROTEÇÃO DOS SEUS DADOS
        </Typography>
        <Typography paragraph>
          8.1. O controlador de dados (clínicas, prestadores de serviço de
          saúde, médicos e profissionais de saúde) e o operador de dados,
          protegem a confidencialidade de dados pessoais e dados sensíveis que
          lhe são confiados pelos titulares desses dados. Para isso, vêm
          implementando medidas de segurança, técnicas e administrativas, aptas
          a proteger dados pessoais e dados sensíveis contra acessos não
          autorizados e de situações acidentais, ou qualquer forma de tratamento
          inadequado, necessárias ao cumprimento da Lei Geral de Proteção de
          Dados (Lei nº 13.709/2018). Regras de boas práticas e de governança
          garantem que o tratamento de dados pessoais e sensíveis seja lícito,
          leal, transparente e limitado às finalidades autorizadas a que se
          destina. A coleta de dados pessoais e dados sensíveis para tratamento
          é realizada pelas Partes com base em medidas necessárias para
          assegurar a exatidão, integridade, confidencialidade, e anonimização,
          bem como garantir o respeito à liberdade, privacidade, inviolabilidade
          da intimidade, imagem, enfim, todos os direitos dos titulares,
          inclusive o exercício do direito de solicitar acesso, correção e
          eliminação de dados pessoais e sensíveis armazenados em banco de dados
          e sistemas digitais.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          9. EXCLUSÃO E RETENÇÃO DE DADOS, INCLUSIVE DO USUÁRIO GOOGLE
        </Typography>
        <Typography paragraph>
          9.1 Armazenamos suas informações pessoais por um período de tempo
          consistente e em conformidade com as legislações vigentes. o Fluxmed
          disponibiliza funcionalidade para que você possa cancelar sua conta no
          Fluxmed, quando VOCÊ cancela sua conta, iremos disponibilizar para
          "download", todas as suas informações contidas no Fluxmed. Faça o
          download e guarde em dispositivo seguro. É seu direito.
        </Typography>
        <Typography paragraph>
          9.2. Controladores de dados tem a responsabilidade de reter seus dados
          conforme diz a Resolução CFM nº 1.821/2007. Cabe a VOCÊ procurar os
          prestadores de serviços de saúde, clínicas, médicos e profissionais
          que utilizaram o Fluxmed para registro do seu atendimento, e solicitar
          a exclusão dos seus dados.
        </Typography>
        <Typography paragraph>
          9.2.1. Uma vez recebido a solicitação de exclusão de seus, dados pelo
          Controlador de dados, eles serão excluídos da Plataforma no prazo de
          24 horas e você será notificado no e-mail cadastrado.
        </Typography>
        <Typography paragraph>
          9.3.O Fluxmed permite que VOCÊ revogue o compartilhamento e o
          consentimento de acesso seus dados, uma vez configurado por VOCÊ, seus
          dados não poderão ser visualizados, baixados ou processados pela
          plataforma.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          10. INTEGRAÇÃO COM MODELOS DE IA - INTELIGÊNCIA ARTIFICIAL GENERATIVOS
        </Typography>
        <Typography paragraph>
          10.1 A integração com modelos de inteligência artificial generativa
          promovida pelo Fluxmed, tem o objetivo de fornecer ao usuário
          facilidade para realização de interações com modelos de IA, sem a
          necessidade dos usuários alternarem para outras aplicações.
        </Typography>
        <Typography paragraph>
          10.2 O Fluxmed não envia nenhum dado para o modelo de inteligência
          artificial generativa de forma deliberativa, sem que o controlador de
          dados realize a operação.
        </Typography>
        <Typography paragraph>
          10.3 O Fluxmed recomenda fortemente que o controlador de dados nunca
          forneçer para o modelo de inteligência artificial generativa,
          informações de dados pessoais dos dados controlados por VOCÊ, seja um
          profissional de saúde ou usuário paciente.
        </Typography>
        <Typography paragraph>
          10.4 O uso de dados brutos ou derivados do usuário recebidos das APIs
          do Google Workspace, A Fluxmed obedecerá à Política de Dados do
          Usuário do Google, incluindo os requisitos de Uso Limitado.
          https://developers.google.com/photos/support/api-policy?sjid=13090456419366852076-SA#limited_use_of_user_data.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          11. INSTRUÇÕES FINAIS PARA O BOM USO DO APLICATIVO E LIMITES
        </Typography>
        <Typography paragraph>
          11.1. Ao utilizar a Plataforma Fluxmed VOCÊ reconhece e concorda que a
          disponibilidade e o funcionamento da Plataforma Fluxmed, como qualquer
          tecnologia de informação e comunicação estão sujeitos a interrupções
          devido a fatores que estão fora do controle da Fluxmed, incluindo, mas
          não se limitando a:
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <li>
            <Typography component="span">
              11.1.1. Indisponibilidade de energia elétrica;
            </Typography>
          </li>
          <li>
            <Typography component="span">
              11.1.2. Falhas no sinal de internet e velocidade inadequada de
              conexão;
            </Typography>
          </li>
          <li>
            <Typography component="span">
              11.1.3. Falhas de software em reparação;
            </Typography>
          </li>
          <li>
            <Typography component="span">
              11.1.4. Desastres ambientais.
            </Typography>
          </li>
        </List>
        <Typography paragraph>
          11.2. Em casos de interrupções devido a manutenções programadas,
          falhas de software ou qualquer outro fator que afete a disponibilidade
          da Plataforma Fluxmed, VOCÊ pode tomar as seguintes ações:
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <li>
            <Typography component="span">
              11.2.1. Verificar comunicados. Pode ser que exista alguma
              notificação indicando a indisponibilidade.
            </Typography>
          </li>
          <li>
            <Typography component="span">
              11.2.2. Reportar problemas. Se encontrar um problema não
              comunicado previamente, é útil reportá-lo à equipe de suporte
              técnico da plataforma Fluxmed por meio do e-mail:
              contato@fluxmed.com.br.
            </Typography>
          </li>
          <li>
            <Typography component="span">
              11.2.3. Revisar este termo. Recomendamos que VOCÊ revise este
              Termo sempre que quiser ou quando for necessário.
            </Typography>
          </li>
        </List>
        <Typography paragraph>
          11.3. O uso da Plataforma Fluxmed é condicionado à adesão integral
          destes termos.
        </Typography>
        <Typography paragraph>
          11.4. Reiteramos: no caso de urgência ou emergência procure o
          atendimento presencial, o pronto atendimento ou pronto socorro mais
          próximo a VOCÊ.
        </Typography>
      </Box>
    </Container>
  ) : (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h6" align="center" gutterBottom fontWeight={700}>
        TERMOS DE USO DA PLATAFORMA FLUXMED
      </Typography>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          1. CONSIDERAÇÕES INICIAIS
        </Typography>
        <Typography paragraph>
          1.1. O presente documento contém os termos e as condições de uso da
          FLUXMED – PLATAFORMA PARA SERVICOS DIGITAIS DE SAUDE LTDA, empresa de
          tecnologia com sede em Brasília-DF, inscrita no CNPJ nº
          57.877.539/0001-40, situada no SIG QUADRA 1, 385, sala 313, Zona
          Industrial, CEP: 70.610-410, Brasília/DF,será referida como "Fluxmed",
          "Pataforma Fluxmed" ou simplesmente "Plataforma". Este documento é de
          adesão por parte do Contratante identificada por meio da Fluxmed no
          momento de criação de seu cadastro de CNPJ (Contratante).
        </Typography>
        <Typography paragraph>
          1.2. A Contratante e a Fluxmed, sempre que em conjunto referidas, para
          efeitos deste documento de adesão, serão designadas como "Partes" ou,
          individualmente, como "Parte", e concordam, em boa-fé e com livre e
          espontânea vontade, o quanto segue.
        </Typography>
        <Typography paragraph>
          1.3. Preliminarmente, considerando que:
        </Typography>
        <Typography paragraph>
          1.3.1. A Contratante é uma organização de saúde que exerce atividades
          de atenção à saúde humana. O CNPJ e CNAE da Contratante será
          verificado junto à Receita Federal no momento da realização do
          cadastro na Plataforma.
        </Typography>
        <Typography paragraph>
          1.3.2. A Fluxmed é uma empresa de tecnologia que exerce atividades de
          tecnologia da informação voltadas para o desenvolvimento de programas
          de computador sob encomenda. É a detentora da marca "Fluxmed",
          conforme certificado de registro de marca emitido pelo Instituto
          Nacional da Propriedade Industrial ("INPI"), n. 922355134, bem como de
          todos os direitos materiais e imateriais a ela relacionados.
        </Typography>
        <Typography paragraph>
          1.3.3. A Fluxmed é a desenvolvedora e detentora de todos os direitos
          de propriedade material e imaterial relacionados ao software que
          compreende a Plataforma Interoperável de Desenvolvimento de Serviços
          Digitais para a Saúde ("Plataforma") denominada "Plataforma Fluxmed".
        </Typography>
        <Typography paragraph>
          1.3.4. A Plataforma consiste em 03 (três) funcionalidades,
          desenvolvidas em conformidade com a Lei Geral de Proteção de Dados
          Pessoais (Lei n. 13.709/2018 – "LGPD"):
        </Typography>

        <Box pl={4}>
          <Typography paragraph>
            1.3.4.1. Fluxmed Siis: ideal para, por exemplo, consultórios
            individuais, pequenas clínicas, credenciados ou não de planos de
            saúde. Permite o registro clínico, agendamento para pacientes e
            profissionais de saúde, teleatendimento, prescrições eletrônicas
            CFM/ICP Brasil. Consiste em um Registro Eletrônico de Saúde (SRES)
            do paciente, atendendo aos padrões de representação, terminologia e
            interoperabilidade de forma integrada em padrão HL7 FHIR.
          </Typography>
          <Typography paragraph>
            1.3.4.2. Fluxmed API´s: plataforma de interoperabilidade HL7 FHIR
            cujo público-alvo são os interessados em utilizar os recursos da
            Plataforma em produtos ou sistemas de terceiros ou próprios,
            permitindo o acesso padronizado HL7 FHIR a uma moderna plataforma de
            desenvolvimento para serviços digitais de saúde, que entrega valor
            agregado, agendamentos, registros clínicos, MPI, gestão de
            terminologias e data lake de informações clínicas, e ainda,
            interoperabilidade escalável. Trata-se de serviço acessório que
            estará sujeito às condições de termo de uso específico com preço
            específico.
          </Typography>
          <Typography paragraph>
            1.3.4.3. Fluxmed Analítico: permite o tratamento de dados já
            ingeridos e processados na Plataforma e, consequentemente a gestão
            de saúde populacional, administrativas e do cuidado a partir do da
            base de dados com informações clínicas e administrativas
            normalizadas, é possível criar painéis analíticos anonimizados,
            alinhados às necessidades de gestão de saúde populacional e muito
            mais, com segurança e sigilo. Trata-se de serviço acessório que
            estará sujeito às condições de termo de uso específico com preço
            específico.
          </Typography>
        </Box>

        <Typography paragraph>
          1.3.5. Em resumo, a Plataforma consiste em um software que realiza
          funções de comunicação e arquivamento de dados de saúde (prontuário
          eletrônico, agendamento, transmissão de dados e comunicação). Assim
          sendo, a Plataforma não oferece funcionalidades relacionadas a
          prevenção, diagnóstico, tratamento, reabilitação ou anticoncepção e,
          desta forma, ela não se enquadra nas regras descritas na Resolução da
          Diretoria Colegiada (RDC) nº 185 de 22 de outubro de 2001 e na RDC nº
          657/2022, ambas da Agência Nacional de Vigilância Sanitária (Anvisa).
          Portanto, a Plataforma não é considerada um software como dispositivo
          médico (Software as a Medical Device – SaMD) e não precisa ser
          regularizada junto a Gerência de Tecnologia em Equipamentos
          (GQUIP/GGTPS/ANVISA).
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          2. OBJETO
        </Typography>
        <Typography paragraph>
          2.1. Este documento tem a finalidade de determinar as condições e os
          termos de uso da Plataforma Fluxmed e as obrigações das Partes cujo
          objeto compreende:
        </Typography>
        <Typography paragraph>
          2.1.1. A adesão, por parte da Contratante, de uso do software
          denominado Fluxmed.
        </Typography>
        <Typography paragraph>
          2.2. Incluídos no preço de subscrição, os serviços atrelados ao objeto
          do Documento e prestados pela Fluxmed serão os seguintes:
        </Typography>

        <Box pl={4}>
          <Typography paragraph>
            2.2.1. Suporte Técnico e Manutenção: Assistência para resolver
            questões técnicas para que o software funcione de maneira otimizada.
            Isso inclui atualizações regulares para corrigir bugs e melhorar a
            segurança e a disponibilidade. Por padrão as atualizações de
            software referente a correção de bugs, melhoria de segurança e
            disponibilidade serão realizados pela monitoração ativa da
            plataforma. Será disponibilizado um canal digital para abertura de
            chamados de suporte técnico. Será realizada triagem de criticidade
            do chamado com resposta ao cliente em até 24 horas. De acordo com a
            criticidade, alta, média ou baixa, será informado o prazo de ajuste,
            que pode ser de até 5 dias úteis.
          </Typography>
          <Typography paragraph>
            2.2.2. Instalação e Configuração: Ajuda na instalação do software e
            na configuração inicial para assegurar que o software esteja pronto
            para uso conforme as necessidades específicas do usuário da
            Contratante. Os manuais do usuário serão disponibilizados na própria
            Plataforma e integrarão o presente documento.
          </Typography>
          <Typography paragraph>
            2.2.3. Customização: se desejado pela Contratante, serviços que
            adaptam o software às necessidades específicas da Contratante,
            incluindo o desenvolvimento de funcionalidades personalizadas ou
            integrações com outros sistemas, não estão inclusos no preço desta
            subscrição. Para customizações, entre em contato com a Fluxmed
            através do site.
          </Typography>
          <Typography paragraph>
            2.2.4. Backup e Recuperação de Dados: a Plataforma é hospedada
            centralmente via internet/nuvem. O backup da Plataforma será
            automatizado com recursos da nuvem. A Plataforma oferece mecanismos
            para que a Contratante realize backups de seus registros e é a
            responsável por isso.
          </Typography>
          <Typography paragraph>
            2.2.5. Atualizações e Upgrades: Fornecimento de novas versões do
            software para garantir acesso contínuo às últimas funcionalidades,
            melhorias de desempenho e correções de segurança. É possível que
            novas funcionalidades resultem em ajuste no preço.
          </Typography>
        </Box>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          3. RESPONSABILIDADES
        </Typography>
        <Typography paragraph>3.1. A Fluxmed é responsável por:</Typography>

        <Box pl={4}>
          <Typography paragraph>
            3.1.1. Observar com os termos e usos deste documento, manter a
            disponibilidade e qualidade da Plataforma.
          </Typography>
          <Typography paragraph>
            3.1.2. Manter atualizados os Manuais de usuário.
          </Typography>
          <Typography paragraph>
            3.1.3. Investir em constantes evoluções tecnológicas em prol da
            saúde digital.
          </Typography>
          <Typography paragraph>
            3.1.4. No caso de cancelamento ou extinção do Documento, por
            qualquer motivo, a Fluxmed obriga-se a manter a Plataforma
            disponível à Contratante, com acesso apenas de leitura de dados,
            pelo período de 30 (trinta) dias para que a Contratante possa
            proceder com a observância da Lei n. 13.787/2018 que versa sobre a
            digitalização e a utilização de sistemas informatizados para a
            guarda, o armazenamento e o manuseio de prontuário de paciente.
          </Typography>
          <Typography paragraph>
            3.1.5. Notificar a Contratante no caso de incidente de segurança em
            até 48 (quarenta e oito) horas do conhecimento do incidente e
            prestar os esclarecimentos necessários e relacionados ao incidente à
            Contratante.
          </Typography>
          <Typography paragraph>
            3.1.6. Manter a emissão tempestiva de Notas Fiscais eletrônicas,
            referentes à subscrição de uso da Contratante.
          </Typography>
          <Typography paragraph>
            3.1.7. Informar por e-mail a Contratante sobre problemas de
            pagamento mantendo o uso da Plataforma Fluxmed por 10 dias após a
            informação do problema do pagamento.
          </Typography>
        </Box>

        <Typography paragraph>
          3.2. Além das obrigações previstas neste instrumento, e na legislação
          aplicável, a Contratante se compromete, ainda, a:
        </Typography>

        <Box pl={4}>
          <Typography paragraph>
            3.2.1. Efetuar todos os pagamentos da subscrição tempestivamente.
          </Typography>
          <Typography paragraph>
            3.2.2. Garantir e manter uma conexão de internet com velocidade e
            estabilidade suficientes para suportar o desempenho eficaz da
            Plataforma.
          </Typography>
          <Typography paragraph>
            3.2.3. Observar as instruções para a utilização da Plataforma e
            Manuais de usuário
          </Typography>
          <Typography paragraph>
            3.2.4. Não realizar modificações, atualizações ou alterações no
            software (Plataforma) sem a prévia aprovação por escrito da Fluxmed.
            Qualquer modificação desautorizada pode levar a problemas de
            compatibilidade ou funcionamento e resultar em violação das
            condições de uso do software, isentando a Fluxmed de qualquer
            responsabilidade.
          </Typography>
          <Typography paragraph>
            3.2.5. A Contratante está proibida de sublicenciar, alugar ou
            emprestar o uso software (Plataforma) a terceiros.
          </Typography>
          <Typography paragraph>
            3.2.6. Em caso de instabilidades, falhas ou qualquer outro problema
            técnico com o software (Plataforma), a Contratante se obriga a abrir
            chamados de suporte técnico imediatamente ao conhecimento do
            problema.
          </Typography>
        </Box>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          4. LIMITAÇÃO DE RESPONSABILIDADE E FORÇA MAIOR
        </Typography>
        <Typography paragraph>
          4.1. Limitação de Responsabilidade e Força Maior. As Partes declaram e
          concordam que a responsabilidade total da Fluxmed, sob qualquer
          circunstância decorrente ou relacionada ao objeto deste documento, se
          comprovada será limitada à natureza da atuação econômica da Fluxmed e
          suas responsabilidades. Para não haver dúvidas, em nenhuma hipótese a
          Fluxmed será responsabilizada por danos sofridos pelo paciente da
          Contratante relacionados à prestação de serviço de saúde pela
          Contratante.
        </Typography>
        <Typography paragraph>
          4.1.1. Força Maior: Nenhuma das partes será responsável por falhas ou
          atrasos no desempenho de suas obrigações sob este documento devido a
          eventos de força maior, que incluem, mas não se limitam a desastres
          naturais, guerras, atos de terrorismo, greves, falhas ou atrasos de
          Internet, falhas de energia, e intervenções governamentais. Em tais
          circunstâncias, os prazos para o desempenho serão prorrogados por um
          período de tempo razoável, considerando a duração do evento de força
          maior. A seguir encontram-se exemplos que isentam a Fluxmed de
          qualquer responsabilidade perante a Contratante:
        </Typography>

        <Box pl={4}>
          <Typography paragraph>
            4.1.1.1. Falhas na internet contratada pela contratante: a empresa
            de tecnologia não pode ser responsabilizada por problemas de
            conectividade que ocorram devido a falhas na internet contratada
            pela Contratante;
          </Typography>
          <Typography paragraph>
            4.1.1.2. Manutenção programada: interrupções agendadas para
            manutenção ou atualizações do sistema, sobre as quais a Contratante
            foi previamente notificada;
          </Typography>
          <Typography paragraph>
            4.1.1.3. Desastres naturais: eventos fora do controle da empresa,
            como terremotos, furacões, enchentes ou outros desastres naturais
            que afetem a infraestrutura necessária para o serviço;
          </Typography>
          <Typography paragraph>
            4.1.1.4. Ataques cibernéticos de terceiros: ataques por hackers ou
            outras entidades maliciosas que não sejam resultado de negligência
            por parte da Fluxmed;
          </Typography>
          <Typography paragraph>
            4.1.1.5. Falhas de equipamentos da Contratante: problemas causados
            por hardware obsoleto ou mal mantido pela Contratante, que afetem a
            operação do SaaS;
          </Typography>
          <Typography paragraph>
            4.1.1.6. Alterações não autorizadas pela Fluxmed: modificações
            feitas pela Contratante na configuração ou no uso da plataforma sem
            consentimento ou aprovação da Fluxmed;
          </Typography>
          <Typography paragraph>
            4.1.1.7. Conflitos de software causados por terceiros:
            interferências ou incompatibilidades causadas por software ou
            hardware de terceiros não fornecidos pela Fluxmed;
          </Typography>
          <Typography paragraph>
            4.1.1.8. Limitações tecnológicas conhecidas: restrições ou
            limitações tecnológicas da plataforma que são conhecidas e
            documentadas e sobre as quais a Contratante foi informada;
          </Typography>
          <Typography paragraph>
            4.1.1.9. Uso inadequado da plataforma: uso do software de maneira
            contrária às instruções fornecidas ou às práticas recomendadas
            estabelecidas pela Fluxmed;
          </Typography>
          <Typography paragraph>
            4.1.1.10. Força maior: qualquer outro evento fora do controle
            razoável da Fluxmed, como greves, tumultos, guerra, pandemias, ou
            intervenções governamentais que impeçam a continuidade dos serviços;
          </Typography>
        </Box>

        <Typography paragraph>
          4.2. Quando comprovado que o problema técnico reside na nuvem, a
          Fluxmed não será responsável por eventos como instabilidade ou até
          mesmo indisponibilidade da Plataforma.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          5. VIGÊNCIA E PREÇO DOS SERVIÇOS
        </Typography>
        <Typography paragraph>
          5.1. A vigência da subscrição de uso e o preço serão disponibilizados
          online pelos recursos da Plataforma Fluxmed e poderão ser ajustados ao
          longo da evolução tecnológica das funcionalidades. Os pagamentos serão
          antecipados. No caso de extinção antecipada da subscrição, prevalecerá
          o preço contratado e nenhum estorno será efetuado por parte da
          Fluxmed.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          6. RESCISÃO
        </Typography>
        <Typography paragraph>
          6.1. A subscrição poderá ser cancelada pela Contratante a qualquer
          momento pelos mecanismos oferecidos pela Plataforma Fluxmed.
        </Typography>
        <Typography paragraph>
          6.2. A Fluxmed poderá cancelar a subscrição por justo motivo, devendo
          notificar a Contratante com 10 (dez) dias de antecedência. Caso for
          detectado o uso indevido da Plataforma Fluxmed, por parte da
          Contratante, a Fluxmed notificará a Contratante e suspenderá
          imediatamente a subscrição até que seja corrigido.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          7. CONFIDENCIALIDADE
        </Typography>
        <Typography paragraph>
          7.1. As Partes se comprometem a guardar o mais absoluto sigilo das
          informações fornecidas pela outra parte para a consecução do objeto
          deste Documento, consideradas de valor inestimável para ambas,
          comprometendo-se a as usarem-nas apenas para os fins específicos a que
          se refere a presente contratação. A parte que não cumprir esta
          obrigação será responsável por eventuais danos causados que venham a
          ser apurados, oportunamente.
        </Typography>
        <Typography paragraph>
          7.2. As Partes, neste ato, obrigam-se, por si, seus representantes,
          prepostos, empregados e/ou subcontratados a tratar com absoluto sigilo
          e confidencialidade toda e qualquer informação, dados econômicos ou
          técnicos, desenhos, projetos, procedimentos, manuais, disponibilizados
          por ambas durante a vigência do presente documento, não podendo, em
          nenhuma hipótese, revelá-los a terceiros e/ou divulgá-los sob qualquer
          forma e pretexto, ou utilizá-los em proveito próprio ou de terceiros
          para fins estranhos ao do presente documento, salvo mediante expressa
          autorização por escrito dos demais interessados.
        </Typography>
        <Typography paragraph>
          7.3. As partes adotarão rigorosas medidas de proteção das informações
          confidenciais da outra Parte para evitar que elas sejam de qualquer
          modo divulgadas, reveladas, publicadas, vendidas, cedidas ou de
          qualquer outra forma transferidas pela Parte Receptora, seus
          representantes, prepostos, empregados e/ou subcontratados.
        </Typography>
        <Typography paragraph>
          7.4. A Contratante é a única responsável pela origem das informações
          por ela prestadas para a Fluxmed para a consecução dos Serviços ora
          contratados e neste ato expressamente declara que o conteúdo da base
          de vidas e das informações nela contidas e que serão fornecidas à
          Fluxmed não viola qualquer lei ou qualquer direito de terceiros,
          incluindo, sem limitação, direitos de propriedade intelectual e
          direitos autorais, isentando e indenizando a Fluxmed, a qualquer
          tempo, mesmo após a expiração ou término deste documento por qualquer
          motivo, de qualquer responsabilidade que decorra da informação
          equivocada ou falsa dos dados fornecidos à Fluxmed.
        </Typography>
        <Typography paragraph>
          7.4.1. A Fluxmed está isenta de responsabilidade pelo conteúdo de toda
          e qualquer informação, dados pessoais, econômicos ou técnicos
          relacionados ao beneficiário, disponibilizados pela Contratante, a
          qual é responsável pela origem e exatidão das informações que
          disponibilizará à Fluxmed para a realização dos serviços objeto do
          presente instrumento.
        </Typography>
        <Typography paragraph>
          7.5. A Fluxmed expressamente compromete-se a adotar as medidas
          técnicas e organizacionais necessárias para garantir a segurança dos
          dados pessoais dos aderentes da Contratante e evitar a sua alteração,
          perda e acesso não autorizados, dada a natureza pessoal dos dados
          armazenados e os riscos a que estão expostos, quer da ação humana ou o
          ambiente físico ou eletrônico em que estejam armazenados.
        </Typography>
        <Typography paragraph>
          7.6. A Contratante está ciente, ainda, de que o prontuário, guias,
          informativos enviados pela Fluxmed aos beneficiários são documentos
          não compartilháveis, cuja propriedade pertence exclusivamente ao
          beneficiário, sendo que Fluxmed reserva o direito de não fornecer
          cópia à Contratante, em hipótese alguma, sob pena de violação do
          sigilo e privacidade do beneficiário, exceto mediante o consentimento
          inequívoco, nos termos da Lei.
        </Typography>
        <Typography paragraph>
          7.7. As obrigações relativas à confidencialidade das informações
          técnicas e de negócio, trocadas entre as Partes para a execução deste
          Documento, perdurarão pelo prazo de 02 (dois) anos após a extinção
          deste Documento, exceto no que se tratar de segredo comercial e
          industrial, e direitos personalíssimos de indivíduos, como dados
          pessoais sensíveis.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          8. PRIVACIDADE E PROTEÇÃO DE DADOS PESSOAIS
        </Typography>
        <Typography paragraph>
          8.1. Relativamente à Lei Geral de Proteção de Dados Pessoais (Lei
          13.709/2018 – LGPD), sem prejuízo das demais disposições dispostas
          neste instrumento, as Partes declaram o seguinte:
        </Typography>
        <Typography paragraph>
          8.1.1. As Partes protegem a confidencialidade de dados pessoais e
          dados sensíveis que lhe são confiados pelos titulares desses dados em
          razão deste documento. Declaram, inclusive em nome de seus empregados,
          cooperados, prepostos e subcontratados que cumprem a legislação
          brasileira sobre privacidade, disposta na Constituição Federal, o
          Código de Defesa do Consumidor, o Código Civil, a Lei Geral de
          Proteção de Dados "LGPD" (Lei Federal nº 13.709/2018), o Marco Civil
          da Internet (Lei Federal nº 12.965/2014), seu decreto regulamentador
          (Decreto nº 8.771/2016) e demais normas setoriais ou gerais sobre
          proteção de dados pessoais. Para isso, vêm implementando medidas de
          segurança, técnicas e administrativas, aptas a proteger dados pessoais
          e dados sensíveis contra acessos não autorizados e de situações
          acidentais, ou qualquer forma de tratamento inadequado, necessárias ao
          cumprimento da Lei Geral de Proteção de Dados (Lei nº 13.709/2018).
        </Typography>
        <Typography paragraph>
          8.1.2. Regras de boas práticas e de governança garantem que o
          tratamento de dados pessoais e sensíveis seja lícito, leal, limitado
          às finalidades autorizadas a que se destina e respeitando-se os
          princípios da transparência, necessidade, proporcionalidade e
          não-discriminação. A coleta de dados pessoais e dados sensíveis para
          tratamento é realizada pelas Partes com base em medidas necessárias
          para assegurar a exatidão, integridade, confidencialidade, e
          anonimização, bem como garantir o respeito à liberdade, privacidade,
          inviolabilidade da intimidade, imagem, enfim, todos os direitos e
          liberdades dos titulares, inclusive o exercício do direito de
          solicitar acesso, correção e eliminação de dados pessoais e sensíveis
          armazenados em banco de dados e sistemas digitais, exceto quando a
          conservação permitida por lei ou obrigação regulatória (art. 16. I da
          LGPD)
        </Typography>
        <Typography paragraph>
          8.1.3. As Partes deverão possuir política de privacidade, diretrizes
          de segurança da informação e mecanismos de mitigação de riscos, com
          vistas a garantir a segurança do tratamento de dados pessoais e dados
          pessoais sensíveis, por exemplo, relatório de impacto à proteção de
          dados pessoais (art. 5º, XVII da LGPD), a fim de evitar incidentes de
          segurança como vazamento de informações, inclusive causados
          internamente, com evidências acessíveis de que tal conteúdo é
          comunicado e disseminado para todos seus aderentes.
        </Typography>
        <Typography paragraph>
          8.1.4. Para fins deste Documento a Fluxmed atua como "Operador de
          dados", nos termos da LGPD e a Contratante atua como "Controlador de
          dados", nos termos da LGPD.
        </Typography>
        <Typography paragraph>
          8.1.4.1. A Fluxmed responderá solidariamente com a Contratante pelos
          danos causados pelo tratamento quando ficar comprovado que ela
          descumpriu as obrigações da legislação de proteção de dados ou quando
          não tiver seguido as instruções lícitas da Contratante, salvo nos
          casos de exclusão previstos no art. 43 da LGPD.
        </Typography>
        <Typography paragraph>
          8.1.4.2. A Contratante responderá solidariamente com a Fluxmed pelos
          danos causados ao titular pelo tratamento que estiverem diretamente
          envolvidos, salvo nos casos de exclusão previstos no art. 43 da LGPD.
        </Typography>
      </Box>

      <Box component="section" mt={4}>
        <Typography variant="h6" gutterBottom>
          9. DISPOSIÇÕES GERAIS E FINAIS
        </Typography>
        <Typography paragraph>
          9.1. O presente documento é firmado por pessoas inteiramente
          distintas, não podendo vir a ser caracterizado como qualquer forma de
          sociedade ou associação, sendo certo que as Partes não terão qualquer
          outro tipo de relação, a não ser o decorrente da relação regida por
          este Documento.
        </Typography>
        <Typography paragraph>
          9.2. Cada Parte será totalmente responsável por suas obrigações
          trabalhistas, fiscais ou civis, contraídas, inexistindo qualquer forma
          de vínculo trabalhista entre as Partes, e outras pessoas jurídicas de
          qualquer forma relacionadas com este Documento;
        </Typography>
        <Typography paragraph>9.3. As Partes comprometem-se a:</Typography>
        <Typography paragraph>
          9.3.1. Agir dentro das leis e regulamentos aplicáveis e obedecer aos
          mais estritos e rigorosos conceitos e princípios da ética, moralidade
          e boa-fé na condução dos negócios conjuntos, incluindo, mas não se
          limitando, a evitar relações, contatos e/ou parcerias comerciais com
          quaisquer agentes que por qualquer meio sabidamente participem ou
          tenham participado em atividades ilícitas, de qualquer espécie;
        </Typography>
        <Typography paragraph>
          9.3.2. Possuir todas as autorizações e licenças para operar seu
          negócio da forma como atualmente é operado e manter, durante o período
          de vigência deste Documento, todas as aprovações, permissões,
          registros e autorizações governamentais ou não governamentais TERMOS
          DE USO DA FLUXMED.
        </Typography>
      </Box>
    </Container>
  );
}
